export default __webpack_public_path__ + "static/media/1927.8331ecc9.png";